import { render, staticRenderFns } from "./uploadImage.vue?vue&type=template&id=31ae0c6f&"
import script from "./uploadImage.vue?vue&type=script&lang=ts&"
export * from "./uploadImage.vue?vue&type=script&lang=ts&"
import style0 from "./uploadImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports